import React from 'react';
import { Link } from 'react-router-dom';
import getURLParameters from '../../helpers/getURLParams';
import getPriceData from '../../helpers/getPriceData';
import countriesAndStates from '../../testing/mocks/countriesAndStates';
import { initializeFormValidation } from '../../helpers/forms/form-validation';
import initializeLocations, { getStates } from '../../helpers/forms/location-form';
import customRequest from '../../helpers/customRequest';
import redirect from '../../components/redirect/redirect';
import message from '../../components/message/message';
import ClipLoader from 'react-spinners/ClipLoader'


class PurchaseOrder extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            students: 0,
            training: 0,
            certification: 0,
            discountCode: null,
            price: "~~~",
            loading: true,
            submitting: false,

            countriesOptions: []
        }
    }

    componentDidMount() {
        let params = getURLParameters();

        if (params.students && params.training && params.certification) {
            this.setState({
                students: params.students,
                training: params.training,
                certification: params.certification,
                discountCode: params.discount,
                valid: true
            });
            if (params.discount) {
                this.setState({
                    "discount-code": params.discount
                });
            }
        }

        let infoPromise = customRequest.get('/api/account/info')

        customRequest.get("/api/countries")
        .then(({data: countriesData}) =>
        {
            this.setState({
				countriesOptions: countriesData.countries
            }, async () => {
                let {data: infoResponse} = await infoPromise

                let setField = (field, value) => {
                    let domField = document.getElementById(field)
                    if (domField) {
                        domField.value = value
                    }
                }
                var {name, email, city, country, state, postalCode, phoneNumber, faxNumber} = infoResponse
    
                setField("city", city)
                setField("postal-code", postalCode)
                setField("contact-name", name)
                setField("contact-phone-number", phoneNumber)
                setField("contact-email-address", email)
                setField("country", country)
                setField("state-autofill", state)
                getStates(document.getElementById("country"))
                this.setState({loading: false})
            })
        })

        this.setState({
            countriesOptions: countriesAndStates.countries //todo: replace with ajax call
        }, () => {
            // initialize scripts for form
            initializeLocations();
            initializeFormValidation(this.onSubmit);
        });

        getPriceData(params.students, params.training, params.certification, params.discount)
        .then((response) => {
            this.setState({price: response.price})
        })
    }

    onSubmit = () => {

        let getField = (field) => {
            let domField = document.getElementById(field)
            if (domField) {
                return domField.value
            }
        }

        this.setState({loading: true, submitting: true})

        customRequest.post("/api/subscription/purchase-order", {
            name: getField("contact-name"),
            city: getField("city"),
            state: getField("state"),
            postalCode: getField("postal-code"),
            country: getField("country"),
            emailAddress: getField("contact-email-address"),
            phone: getField("contact-phone-number"),
            school: getField("school"),
            district: getField("district"),
            price: this.state.price,
            training: this.state.training,
            certification: this.state.certification,
            students:this.state.students,
            purchaseOrderNumber: getField("purchase-order-number"),
            discountCode: this.state.discountCode
        })
        .then(({data: response}) => {
            this.setState({loading: false, submitting: false})
            if (response.valid) {
                redirect.send("/", () => {
                    message.success("Thank you for submitting a purchase order, we will get back with you shortly.")
                })
            }
            else if (response.valid == false) {
                message.error(response.message)
            }
            else {
                message.error("Looks like there was an internal error.")
            }
        })
    }

    render() {
        return (
            <React.Fragment>
                <h1>Subscribe to Great Leaps with a Purchase Order</h1>

                <div class="row subheader-text">
                    <div class="col-sm-10 offset-sm-1 col-md-8 offset-md-2">
                        <p>Enter your purchase order information below, and we'll follow up with you shortly with more information.</p>
                    </div>
                </div>

                <form class="form-horizontal form-validate" method="post">
                    <div class="form-group row">
                        <label class="col-sm-3 control-label text-right">Students</label>

                        <div class="col-sm-6">
                            <p class="form-control-static text-left text-center-xs">{this.state.students}</p>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-3 control-label text-right">Training</label>

                        <div class="col-sm-6">
                            <p class="form-control-static text-left text-center-xs">{this.state.training}</p>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-3 control-label text-right">Certification</label>

                        <div class="col-sm-6">
                            <p class="form-control-static text-left text-center-xs">{this.state.certification}</p>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-sm-3 control-label text-right">Price</label>

                        <div class="col-sm-6">
                            <p class="form-control-static text-left text-center-xs">{"$" +  this.state.price }</p>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="purchase-order-number" class="d-none d-sm-inline col-sm-3 control-label text-right">Purchase Order Number</label>

                        <div class="col-sm-6">
                            <input type="text" class="form-control" disabled={this.state.loading} id="purchase-order-number" name="purchase-order-number" placeholder="Purchase Order Number" data-description="enter a purchase order number" required autoFocus />
                        </div>
                    </div>


                    <div class="form-group row">
                        <label for="district" class="d-none d-sm-inline col-sm-3 control-label text-right">District</label>

                        <div class="col-sm-6">
                            <input type="text" class="form-control string" disabled={this.state.loading}  id="district" name="district" placeholder="District" maxlength="175" data-description="enter a district" required />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="school" class="d-none d-sm-inline col-sm-3 control-label text-right">School</label>

                        <div class="col-sm-6">
                            <input type="text" class="form-control string" disabled={this.state.loading}  id="school" name="school" placeholder="School" maxlength="175" data-description="enter a school" required />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="country" class="d-none d-sm-inline col-sm-3 control-label text-right">Country</label>

                        <div class="col-sm-6">
                            <select class="form-control" disabled={this.state.loading}  name="country" id="country" required data-description="select a country">
                                <option value="" disabled selected>Country:</option>
                                {this.state.countriesOptions.map((item) => {
                                    return (<option value={item}>{item}</option>)
                                })}
                            </select>
                        </div>
                    </div>

                    <div class="state-autofill-target">
                        <input type="text" name="state-autofill" disabled={this.state.loading}  id="state-autofill" readOnly />
                    </div>

                    <div class="form-group row">
                        <label for="state" class="d-none d-sm-inline col-sm-3 control-label text-right">State or Province</label>

                        <div class="col-sm-6">
                            <select class="form-control" disabled={this.state.loading}  name="state" id="state" required data-description="select a state or province"></select>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="city" class="d-none d-sm-inline col-sm-3 control-label text-right">City</label>

                        <div class="col-sm-6">
                            <input type="text" class="form-control string" disabled={this.state.loading}  id="city" name="city" placeholder="City" maxlength="175" data-description="enter a city" required />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="postal-code" class="d-none d-sm-inline col-sm-3 control-label text-right">Postal Code</label>

                        <div class="col-sm-6">
                            <input type="text" class="form-control string" disabled={this.state.loading}  id="postal-code" name="postal-code" placeholder="Postal Code" maxlength="175" data-description="enter a postal code" required />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="contact-name" class="d-none d-sm-inline col-sm-3 control-label text-right">Contact Name</label>

                        <div class="col-sm-6">
                            <input type="text" class="form-control string" disabled={this.state.loading}  id="contact-name" name="contact-name" placeholder="Contact Name" maxlength="175" data-description="enter a contact name" required />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="contact-phone-number" class="d-none d-sm-inline col-sm-3 control-label text-right">Contact Phone Number</label>

                        <div class="col-sm-6">
                            <input type="text" class="form-control string" disabled={this.state.loading}  id="contact-phone-number" name="contact-phone-number" placeholder="Contact Phone Number" maxlength="175" data-description="enter a contact phone number" required />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="contact-email-address" class="d-none d-sm-inline col-sm-3 control-label text-right">Contact Email Address</label>

                        <div class="col-sm-6">
                            <input type="text" class="form-control string" disabled={this.state.loading}  id="contact-email-address" name="contact-email-address" placeholder="Contact Email Address" maxlength="175" data-description="enter a contact email address" required />
                        </div>
                    </div>

                    <button type="submit" class="btn btn-secondary btn-lg" disabled={this.state.loading}>
                        {this.state.submitting ?
                        <ClipLoader
							size={20}
							color={"#123abc"}
							loading={this.state.submitting}
							/> : "Submit"}
                            </button>
                </form>
            </React.Fragment>
        )
    }

}

export default PurchaseOrder;
